import cn from 'classnames';
import { UiTextField } from '@@/ui/components/ui-text-field';
import {
  CreateWarehouseStep,
  ICreateWarehouseStepProps,
} from '@@/warehouses/components/create-warehouse-step';

import styles from './styles.module.css';

export function WarehouseName(props: IWarehouseNameProps) {
  const { className, name, canProceed, onChange, onNext, ...rest } = props;
  const rootClass = cn(styles.root, className);

  return (
    <CreateWarehouseStep
      className={rootClass}
      prev={{ disabled: true }}
      next={{ disabled: !canProceed }}
      onNext={() => onNext(name)}
      {...rest}
    >
      <UiTextField
        label="Название склада"
        value={name}
        required
        onChange={({ value }) => onChange(value as string)}
      />
    </CreateWarehouseStep>
  );
}

export interface IWarehouseNameProps
  extends Omit<ICreateWarehouseStepProps, 'onNext' | 'onChange'> {
  name: string;
  canProceed?: boolean;
  onChange: (name: string) => void;
  onNext: (name: string) => void;
}
